@if (show) {
  <div class="wrapper z-fx-col" [style.min-height.px]="height">
    <div class="background">
      <ng-content select="[background]"></ng-content>
    </div>
    <div class="foreground z-fx z-fx-flex" [class.zef-foreground]="foreground">
      <ng-content></ng-content>
      <div class="icon-action z-fx-center-center">
        @if (closeButton) {
          <button mat-icon-button (click)="onCloseClick($event)">
            <mat-icon class="zef-icon-large" matTooltip="Close" i18n-matTooltip>close</mat-icon>
          </button>
        }
        @if (!closeButton) {
          <ng-content select="[action]"></ng-content>
        }
      </div>
    </div>
  </div>
}
